import React from "react";
import { Link } from "react-router-dom";
import { Mountain, ArrowLeft } from "lucide-react";
import { DISCLAIMER } from "@/lib/constants";

const CONTENT = {
    privacidade: {
        title: "Política de Privacidade",
        sections: [
            ["Coleta de dados", "Coletamos nome, e-mail, telefone, empresa, CREA e profissão fornecidos por você, além dos dados dos processos, prazos e documentos que você cadastra na plataforma."],
            ["Uso dos dados", "Os dados são usados exclusivamente para prestação do serviço de gestão mineral, comunicação de alertas e melhoria da plataforma. Cada usuário acessa somente seus próprios dados."],
            ["Assistente de IA", "Consultas ao Assistente ANM IA são processadas por provedor de IA de terceiros. Não compartilhamos dados de processos além do necessário para gerar a resposta solicitada."],
            ["Seus direitos (LGPD)", "Você pode alterar seus dados, solicitar exclusão da conta e dos dados a qualquer momento em Configurações. Consentimentos relevantes são registrados."],
            ["Segurança", "Aplicamos autenticação, autorização por usuário, criptografia em trânsito (HTTPS) e proteção das APIs. Segredos e chaves ficam exclusivamente no servidor."],
        ],
    },
    termos: {
        title: "Termos de Uso",
        sections: [
            ["Natureza da plataforma", DISCLAIMER],
            ["Caráter informativo", "As informações regulatórias e as respostas da IA possuem caráter informativo e não substituem análise técnica, jurídica ou manifestação oficial da ANM. Confirme sempre nas fontes oficiais."],
            ["Assinatura", "O plano Geomine Manager Profissional custa R$ 749,00/mês, com cobrança recorrente e limite de até 3 processos ANM. Você pode cancelar quando quiser."],
            ["Responsabilidades", "O usuário é responsável pela veracidade dos dados inseridos. A plataforma não se responsabiliza por decisões tomadas exclusivamente com base nas informações aqui apresentadas."],
        ],
    },
    cookies: {
        title: "Política de Cookies",
        sections: [
            ["Cookies essenciais", "Utilizamos cookies estritamente necessários para autenticação e manutenção da sessão segura do usuário."],
            ["Cookies de preferência", "Podemos armazenar preferências para melhorar sua experiência de navegação."],
            ["Gerenciamento", "Você pode gerenciar cookies nas configurações do seu navegador. A desativação de cookies essenciais pode impedir o login."],
        ],
    },
};

export default function Legal({ page }) {
    const data = CONTENT[page] || CONTENT.termos;
    return (
        <div className="min-h-screen bg-white">
            <header className="border-b border-slate-200">
                <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2 font-heading font-black text-lg text-petroleum">
                        <Mountain className="w-6 h-6 text-mineral" /> GEOMINE MANAGER
                    </Link>
                    <Link to="/" className="text-sm text-slate-500 hover:text-petroleum flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Início</Link>
                </div>
            </header>
            <div className="max-w-3xl mx-auto px-6 py-14" data-testid={`legal-${page}`}>
                <h1 className="font-heading text-3xl font-black text-slate-900">{data.title}</h1>
                <div className="mt-8 space-y-8">
                    {data.sections.map(([t, body]) => (
                        <section key={t}>
                            <h2 className="font-heading text-lg font-bold text-slate-800">{t}</h2>
                            <p className="mt-2 text-slate-600 leading-relaxed">{body}</p>
                        </section>
                    ))}
                </div>
                <p className="mt-12 text-xs text-slate-400">{DISCLAIMER}</p>
            </div>
        </div>
    );
}
